import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=2ec8b1e5&scoped=true&"
import script from "./PhoneNumber.vue?vue&type=script&lang=js&"
export * from "./PhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumber.vue?vue&type=style&index=0&id=2ec8b1e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8b1e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAppBar,VBtn,VCard,VCardSubtitle,VCardText,VCol,VDivider,VIcon,VRow,VTextField})
